import * as yup from 'yup';
import { useGetCustomViewsQuery } from '../../../../../API/pcDashboard/CustomViewsApi';
import { useMemo } from 'react';
import { UUID } from '../../../../../types/shared/UUID';

export const useGenerateCustomViewValidation = (id: UUID = '') => {
  const { data = {} } = useGetCustomViewsQuery();
  return useMemo(() => {
    const { [id]: _, ...rest } = data;
    const names = new Set(Object.values(rest).map(({ name }) => name));
    const keys = new Set(Object.values(rest).map(({ keyboardKey }) => keyboardKey));
    return yup.object().shape({
      description: yup.string().max(100, 'The description has a 100 character limit'),
      keyboardKey: yup
        .string()
        .length(1, 'A shortcut key cannot be greater than one character')
        .required()
        .test('not-k', 'The K key is reserved for Jump', (value = '') => !/[kK]/.test(value))
        .test('not-qw', 'The Q and W keys are not permitted', (value = '') => !/[qQwW]/.test(value))
        .test('lowercase', 'Please use a lowercase letter or a number', (value = '') => /[a-z0-9]/.test(value))
        .test('unique-key', 'This key must be unique', (value = '') => !keys.has(value)),
      name: yup
        .string()
        .required()
        .test('unique-name', 'This name must be unique from other names', (value = '') => !names.has(value))
        .max(25, 'The name has a 25 character limit'),
      search: yup.string().required(),
    });
  }, [data, id]);
};
